import { InternalTitle, UserRoleType, User } from 'BaseDataTypes';

export interface Project {
  id: number;
  name: string;
  customerId: number;
  latisNum?: number;
  projectManagerId?: number;
  customer: Customer;
  closedDate?: Date | null;
}

export interface Customer {
  id: number;
  name: string;
}

export interface RequisitionNumber {
  id: number;
  projectId: number;
  project?: Project;
  reqNumber: string;
  taskDescription: string;
  date: Date;
  requisitionStatus: RequisitionStatus;
  comment?: string;
  requisitionTaskStatus: RequisitionTaskStatus;
  userId: number;
  user?: User;
}

export enum RequisitionStatus {
  Open = 'Open',
  Closed = 'Closed',
  Invoiced = 'Invoiced',
  IOPetition = 'IOPetition',
  PartiallyInvoiced = 'PartiallyInvoiced',
}

/**
 * Translations for the RequisitionStatus to danish text value
 */
export const RequisitionStatusTranslations: {
  [key in RequisitionStatus]: string;
} = {
  [RequisitionStatus.Open]: 'Åben',
  [RequisitionStatus.Closed]: 'Lukket',
  [RequisitionStatus.Invoiced]: 'Faktureret',
  [RequisitionStatus.IOPetition]: 'IO begæring',
  [RequisitionStatus.PartiallyInvoiced]: 'Delvis Faktureret',
};

export enum RequisitionTaskStatus {
  Waiting = 'Waiting',
  InProgress = 'InProgress',
  Completed = 'Completed',
  Planned = 'Planned',
  Problem = 'Problem',
  PartiallyCompleted = 'PartiallyCompleted',
  NotAvailable = 'NotAvailable',
}

/**
 * Translations for the RequisitionTaskStatus to danish text value
 */
export const RequisitionTaskStatusTranslations: {
  [key in RequisitionTaskStatus]: string;
} = {
  [RequisitionTaskStatus.Waiting]: 'Afventer',
  [RequisitionTaskStatus.InProgress]: 'Igang',
  [RequisitionTaskStatus.Completed]: 'Færdig',
  [RequisitionTaskStatus.Planned]: 'Planlagt',
  [RequisitionTaskStatus.Problem]: 'Problem',
  [RequisitionTaskStatus.PartiallyCompleted]: 'Delvis færdig',
  [RequisitionTaskStatus.NotAvailable]: 'n/a',
};

export interface TimelogSheet {
  id: number;
  sheetId: string;
  sheetName: string;
  userId: number;
}
